import { __, assoc, compose, equals, findIndex, length, path, propEq, when } from 'ramda'

export default {
  /**
   * Sets the loading value.
   *
   * @param {Object} state
   * @param {boolean} loading
   */
  SET_LOADING(state, loading) {
    state.loading = loading
  },

  /**
   * Replaces the order entities with a new list.
   *
   * @param {Object} state
   * @param {Array} orders
   */
  SET_ORDERS(state, orders) {
    state.orders = orders
  },

  /**
   * Updates an order in the state.
   *
   * @param {Object} state
   * @param {Object} entity
   */
  UPDATE_ORDER(state, entity) {
    state.orders = compose(
      assoc(__, entity, state.orders),
      when(equals(-1), () => length(state.orders)),
      findIndex(propEq('id', path(['id'], entity))),
    )(state.orders)
  },

  /**
   * Sets the entity count value.
   *
   * @param {Object} state
   * @param {Number} entityCount
   */
  SET_ENTITY_COUNT(state, entityCount) {
    state.entityCount = entityCount
  },

  /**
   * Sets the page value.
   *
   * @param {Object} state
   * @param {Number} page
   */
  SET_PAGE(state, page) {
    state.page = page
  },

  /**
   * Sets the filters value.
   *
   * @param {Object} state
   * @param {Object} filters
   */
  SET_FILTERS(state, filters) {
    state.filters = filters
  },
}
